import { render, staticRenderFns } from "./PriceHistory.vue?vue&type=template&id=d155ee8c&scoped=true"
import script from "./PriceHistory.vue?vue&type=script&lang=js"
export * from "./PriceHistory.vue?vue&type=script&lang=js"
import style0 from "./PriceHistory.vue?vue&type=style&index=0&id=d155ee8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d155ee8c",
  null
  
)

export default component.exports